var _defineProperty = require("/private/tmp/ncsacw-website/frontend/node_modules/@babel/runtime/helpers/defineProperty.js");
var behavior = require("../../uswds-core/src/js/utils/behavior");
var toggleFormInput = require("../../uswds-core/src/js/utils/toggle-form-input");
var _require = require("../../uswds-core/src/js/events"),
  CLICK = _require.CLICK;
var _require2 = require("../../uswds-core/src/js/config"),
  PREFIX = _require2.prefix;
var LINK = ".".concat(PREFIX, "-show-password");
function toggle(event) {
  event.preventDefault();
  toggleFormInput(this);
}
module.exports = behavior(_defineProperty({}, CLICK, _defineProperty({}, LINK, toggle)));